/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_No_Terms_To_ExportInputs */

const en_knp_terms_no_terms_to_export = /** @type {(inputs: Knp_Terms_No_Terms_To_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No terms to export`)
};

const fr_knp_terms_no_terms_to_export = /** @type {(inputs: Knp_Terms_No_Terms_To_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun terme à exporter`)
};

const de_knp_terms_no_terms_to_export = /** @type {(inputs: Knp_Terms_No_Terms_To_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Exportbedingungen`)
};

const it_knp_terms_no_terms_to_export = /** @type {(inputs: Knp_Terms_No_Terms_To_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun termine da esportare`)
};

const ru_knp_terms_no_terms_to_export = /** @type {(inputs: Knp_Terms_No_Terms_To_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Условия для экспорта отсутствуют.`)
};

const es_knp_terms_no_terms_to_export = /** @type {(inputs: Knp_Terms_No_Terms_To_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay condiciones para exportar`)
};

const zh_cn2_knp_terms_no_terms_to_export = /** @type {(inputs: Knp_Terms_No_Terms_To_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有出口条款`)
};

const ja_knp_terms_no_terms_to_export = /** @type {(inputs: Knp_Terms_No_Terms_To_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートする用語はありません`)
};

const hi_knp_terms_no_terms_to_export = /** @type {(inputs: Knp_Terms_No_Terms_To_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात के लिए कोई शर्तें नहीं हैं`)
};

const pt_pt2_knp_terms_no_terms_to_export = /** @type {(inputs: Knp_Terms_No_Terms_To_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não há termos para exportar.`)
};

/**
* | output |
* | --- |
* | "No terms to export" |
*
* @param {Knp_Terms_No_Terms_To_ExportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_no_terms_to_export = /** @type {((inputs?: Knp_Terms_No_Terms_To_ExportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_No_Terms_To_ExportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_no_terms_to_export(inputs)
	if (locale === "de") return de_knp_terms_no_terms_to_export(inputs)
	if (locale === "it") return it_knp_terms_no_terms_to_export(inputs)
	if (locale === "ru") return ru_knp_terms_no_terms_to_export(inputs)
	if (locale === "es") return es_knp_terms_no_terms_to_export(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_no_terms_to_export(inputs)
	if (locale === "ja") return ja_knp_terms_no_terms_to_export(inputs)
	if (locale === "hi") return hi_knp_terms_no_terms_to_export(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_no_terms_to_export(inputs)
	return en_knp_terms_no_terms_to_export(inputs)
});